import { Injectable, OnDestroy } from '@angular/core';
import { Subscription } from '../../../../node_modules/rxjs';
import { NavigationHelper } from './navigation-helper';
import { ProcessTypeService } from './process-type.service';
import { SubjectTypeService } from './subject-type.service';
import { Statistic } from '../models/statistic';
import { StatisticsService } from './statistics.service';
import { DefaultDataService, SettingsData, UserData } from './default-data.service';
import { EventService } from './event.service';
import { AutoUnsubscribe } from 'auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Injectable({ providedIn: 'root' })
export class NavigationService implements OnDestroy {
  navigation: any;
  onSubjectTypesChanged: Subscription;
  onProcessTypesChanged: Subscription;
  onTaskStatsChanged: Subscription;
  onChangeSettings: Subscription;
  onChangeUser: Subscription;

  constructor(private subjectTypeService: SubjectTypeService,
    private processTypeService: ProcessTypeService,
    private statisticsService: StatisticsService,
    private defaultDataService: DefaultDataService,
    private eventService: EventService,
  ) {
  }

  init(privs: string) {

    // setup properties from args
    NavigationHelper.privs = privs;
    NavigationHelper.updateNavigation();

    this.onChangeUser = this.eventService.onChangeUser.subscribe((response) => {
      const data: UserData = response as UserData;
      if (data) {
        NavigationHelper.canViewArchive = response.canViewArchive;
        NavigationHelper.updateNavigation();
      }
    });

    this.onChangeSettings = this.eventService.onChangeSettings.subscribe((response) => {
      const data: SettingsData = response as SettingsData;
      if (data) {
        NavigationHelper.markerSearchEnabled = (data.enableMarkerSearch !== undefined) ? data.enableMarkerSearch : this.defaultDataService.enableMarkerSearch;
        NavigationHelper.referralsEnabled = (data.enableReferrals !== undefined) ? data.enableReferrals : this.defaultDataService.enableReferrals;
        NavigationHelper.assessmentsEnabled = (data.enableAssessments !== undefined) ? data.enableAssessments : this.defaultDataService.enableAssessments;
        NavigationHelper.onlineReportingEnabled = (data.enableOnlineReporting !== undefined) ? data.enableOnlineReporting : this.defaultDataService.enableOnlineReporting;
        NavigationHelper.emailTemplatesEnabled = (data.enableEmailTemplates !== undefined) ? data.enableEmailTemplates : this.defaultDataService.enableEmailTemplates;
        NavigationHelper.evidenceUploadEnabled = (data.enableEvidenceUpload !== undefined) ? data.enableEvidenceUpload : this.defaultDataService.enableEvidenceUpload;
        NavigationHelper.enableFOIFeature = (data.enableFOIFeature !== undefined) ? data.enableFOIFeature : this.defaultDataService.enableFOIFeature;
        NavigationHelper.updateNavigation();
      }
    });

    // setup subscription for getting the possible subject types for the various navbar items
    this.onSubjectTypesChanged = this.subjectTypeService.onChanged.subscribe((response) => {
      if (response.length > 0) {
        NavigationHelper.subjectTypes = [...response.filter((x) => !x.hideRecord)];
        NavigationHelper.updateNavigation();
      }
    });

    // setup subscription for getting the possible process types for the various navbar items
    this.onProcessTypesChanged = this.processTypeService.onChanged.subscribe((response) => {
      if (response.length > 0) {
        NavigationHelper.processTypes = [...response.filter((x) => !x.hideRecord)];
        NavigationHelper.updateNavigation();
      }
    });

    // When stats change, look for new Task counts and update nav bar badges.
    this.onTaskStatsChanged = this.statisticsService.onChanged.subscribe((stats: Statistic[]) => {
      // console.log('Updating Task Stats');
      if (stats) {
        const myTasks = this.getStatFromList(stats, 'My Tasks Count');
        if (myTasks > -1) { NavigationHelper.myTasksCount = myTasks; }

        const allTasks = this.getStatFromList(stats, 'All Tasks Count');
        if (allTasks > -1) { NavigationHelper.allTasksCount = allTasks; }

        NavigationHelper.updateNavigation();
      }
    });

  }

  getStatFromList(stats: Statistic[], name: string): number {
    if (stats) {
      const stat = stats.find((s: Statistic) => s.name.toLowerCase() === name.toLowerCase());
      if (stat) {
        return stat.count;
      }
    }
    return -1;
  }

  ngOnDestroy() {
    this.onSubjectTypesChanged?.unsubscribe();
    this.onProcessTypesChanged?.unsubscribe();
    this.onTaskStatsChanged?.unsubscribe();
    this.onChangeSettings?.unsubscribe();
    this.onChangeUser?.unsubscribe();
  }
}
